module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1 && _vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addActivityData
    }
  }, [_vm._v("添加活动")])], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activitycate),
      callback: function($$v) {
        _vm.activitycate = $$v
      },
      expression: "activitycate"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "全部",
      "name": "0"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "社群分享",
      "name": "1"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "限量团购",
      "name": "2"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "会员升级",
      "name": "3"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "赠品活动",
      "name": "4"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "素材分享",
      "name": "5"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.activityList,
      "height": _vm.wheight - 210
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "label": "全选"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "图片",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "right",
            "width": "240",
            "trigger": "hover"
          }
        }, [_c('img', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "src": scope.row.img
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          slot: "reference"
        }, [_c('img', {
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": scope.row.img
          }
        })])], 1)]
      }
    }], null, false, 2412998917)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "标题",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动时间",
      "width": "190"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.start_date) + " "), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("开始")]), _vm._v("\n              " + _vm._s(scope.row.end_date) + " "), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("结束")])]
      }
    }], null, false, 2570357788)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "act_sort",
      "label": "活动排序",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.act_sort),
            expression: "scope.row.act_sort"
          }],
          staticStyle: {
            "width": "50px",
            "border": "1px solid #ddd",
            "line-height": "25px",
            "padding-left": "5px"
          },
          domProps: {
            "value": (scope.row.act_sort)
          },
          on: {
            "change": function($event) {
              return _vm.sortEdit(_vm.node, scope.row)
            },
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(scope.row, "act_sort", $event.target.value)
            }
          }
        })]
      }
    }], null, false, 2069527912)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "activitycate",
      "label": "活动分类",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.activitycate == '1') ? _c('span', [_vm._v("社群分享")]) : (scope.row.activitycate == '2') ? _c('span', [_vm._v("限量团购")]) : (scope.row.activitycate == '3') ? _c('span', [_vm._v("会员升级")]) : (scope.row.activitycate == '4') ? _c('span', [_vm._v("赠品活动")]) : _c('span', [_vm._v("素材分享")])]
      }
    }], null, false, 3775063589)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sku_bns",
      "label": "货号",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "items",
      "label": "商品",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons custom-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-search-plus",
          on: {
            "click": function($event) {
              return _vm.viewGoodsList(scope.row.act_id)
            }
          }
        })])]
      }
    }], null, false, 987628817)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created_date",
      "label": "创建时间",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "btn-gap",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editCommunityAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-popover', {
          attrs: {
            "placement": "right",
            "width": "450",
            "trigger": "hover"
          }
        }, [_c('div', {
          staticClass: "operating-icons"
        }, [_c('el-button', {
          staticClass: "btn-gap",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.deleteItemsAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          slot: "reference"
        }, [_c('i', {
          staticClass: "iconfont icon-angle-double-right"
        })])], 1)]
      }
    }], null, false, 112468099)
  })], 1)], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded tc"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next, total",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "活动商品列表",
      "visible": _vm.goodsVisible,
      "before-close": _vm.handleCancel,
      "width": "70%"
    },
    on: {
      "update:visible": function($event) {
        _vm.goodsVisible = $event
      }
    }
  }, [
    [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      attrs: {
        "data": _vm.goodsList
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "sku_id",
        "label": "商品ID",
        "width": "80"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "sku_bn",
        "label": "商品货号",
        "width": "80"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "sku_name",
        "label": "商品名称"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "max_sell",
        "label": "限量团购",
        "width": "50"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "act_sort",
        "label": "排序",
        "width": "50"
      }
    })], 1), _vm._v(" "), (_vm.goodsCount > _vm.goodsPageSize) ? _c('div', {
      staticClass: "content-center content-top-padded"
    }, [_c('el-pagination', {
      attrs: {
        "layout": "prev, pager, next",
        "current-page": _vm.goodsPage,
        "total": _vm.goodsCount,
        "page-size": _vm.goodsPageSize
      },
      on: {
        "current-change": _vm.handleGoodsCurrentChange,
        "update:currentPage": function($event) {
          _vm.goodsPage = $event
        },
        "update:current-page": function($event) {
          _vm.goodsPage = $event
        }
      }
    })], 1) : _vm._e()]
  ], 2)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-aa4c2972", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa4c2972"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/sharer/activity/activity_list.vue
// module id = 2907
// module chunks = 0